import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import useAppToast from '@/hooks/useAppToast';
import { getInformation, AdminInformationResponse } from '@/services/admin/informations';
import { getApiErrorMessage, isNotFoundError, DEFAULT_FETCH_ERROR_MESSAGE } from '@/utils/apiError';

export const useAdminInformationDetail = (siteType: string, id: number) => {
  const toast = useAppToast();

  const { data, isLoading, isError, error, refetch } = useQuery<AdminInformationResponse>({
    queryKey: ['informations', siteType, id],
    queryFn: () => getInformation(siteType, id),
    enabled: !!siteType && id > 0,
    retry: (failureCount, err) => {
      if (isNotFoundError(err)) return false;
      return failureCount < 3;
    },
  });

  useEffect(() => {
    if (isError && error && !isNotFoundError(error)) {
      toast.error(getApiErrorMessage(error, DEFAULT_FETCH_ERROR_MESSAGE));
    }
  }, [isError, error, toast]);

  return { data, isLoading, isError, error, refetch };
};
